


















import Vue from "vue";
import iwInputSelect from "../buildingBlocks/InputSelect.vue";
import { scrollToPriceInput } from "@/shared/scripts/helpers/function";
import { isPropertyInFlanders } from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    props: {
        submitAttempted: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.epc.score"
        };
    },

    computed: {
        epcScore: function(): string | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },

        isAddressValid: function(): boolean {
            return Boolean(
                this.$store.getters["FormModule/getValue"]("property.location.address")
            );
        },

        shouldValidate: function(): boolean {
            return this.isAddressValid && this.submitAttempted;
        },

        hasError: function(): boolean {
            return this.shouldValidate && !this.epcScore;
        },
        isFlandersAddress: function(): boolean {
            return isPropertyInFlanders(
                this.$store.getters["FormModule/getValue"]("property.location.address.country"),
                this.$store.getters["FormModule/getValue"]("property.location.address.postalCode")
            );
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                // A++ is not a valid EPC value in Flanders (only Brussels and Wallonia)
                ...(this.isFlandersAddress ? [] : [{
                    "label": this.$t("A++"),
                    "value": "A++"
                }]),
                {
                    "label": this.$t("A+"),
                    "value": "A+"
                },
                {
                    "label": this.$t("A"),
                    "value": "A"
                },
                {
                    "label": this.$t("B"),
                    "value": "B"
                },
                {
                    "label": this.$t("C"),
                    "value": "C"
                },
                {
                    "label": this.$t("D"),
                    "value": "D"
                },
                {
                    "label": this.$t("E"),
                    "value": "E"
                },
                {
                    "label": this.$t("F"),
                    "value": "F"
                },
                {
                    "label": this.$t("G"),
                    "value": "G"
                },
                {
                    "label": this.$t("X"),
                    "value": "X"
                }
            ];
        }
    },
    methods: {
        updateValue: function(epcScoreValue: string): void {
            // clear ALL errors if value becomes valid
            if (this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStore)) {
                this.$store.dispatch("FormModule/setErrors", null);
            }

            if (epcScoreValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: epcScoreValue
                });
            }

            this.$nextTick(() => {
                scrollToPriceInput("label[id*=\"input-sale-price-label\"], label[id*=\"input-rent-requested-monthly-price-label\"]");
            });
        }
    },
});

